import { create } from 'zustand';

export const useDashboardStore = create(set => ({
  stateCounties: [],
  setStateCounties: stateCounties => set({ stateCounties }),
}));
